import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  getCapitalFormationSnapshotsList,
  ICapitalFormationSnapshotListReturnType,
} from "api";
import { Nullable } from "config";
import { RootState } from "store/store";

const initialState = {
  data: null as Nullable<ICapitalFormationSnapshotListReturnType["edges"]>,
  totalCount: 1,
  loading: false,
};

export const fetchCapitalFormationSnapshotsData = createAsyncThunk(
  "capital-formation-snapshots/fetchCapitalFormationSnapshotsData",
  async (_, { getState }) => {
    try {
      const filters = (getState() as RootState).FiltersReducer;
      if (!Object.values(filters).length) {
        return;
      }
      const response = await getCapitalFormationSnapshotsList(filters);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

const CapitalFormationSnapshotsSlice = createSlice({
  name: "capital-formation-snapshots",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchCapitalFormationSnapshotsData.fulfilled,
      (state, action) => {
        if (!action.payload) return;
        return {
          ...state,
          data: action.payload
            ?.edges as ICapitalFormationSnapshotListReturnType["edges"],
          totalCount: action.payload?.totalCount,
          loading: false,
        };
      }
    );
    builder.addCase(fetchCapitalFormationSnapshotsData.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(fetchCapitalFormationSnapshotsData.rejected, (state) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

export default CapitalFormationSnapshotsSlice.reducer;
